/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { Modal } from 'antd-mobile'
import { AdvDialogStyle } from '@styles/modal'
import { isMobile } from 'react-device-detect'
import AdvCasino from '@views/AdvCasino'
// img
import CasinoOpenImg from '@assets/images/casino/banner/casino-open-banner.png'
// css
import { ModalBg } from '@styles/base.style'
import { Button, CloseBtn } from '@styles/button.style'
import { loadOrReload, updateCasinoAdvertisementImageLastShowedAt } from '@utils/utils'
import { CasinoOpenWrap } from './index.style'

const AdvCasinoOpenPopup: React.FC = () => {
  const { globalStore } = useRootStore()
  const { visibleCasinoOpenPopup } = globalStore

  const onCloseModal = () => {
    globalStore.setVisibleCasinoOpenPopup(false)
    updateCasinoAdvertisementImageLastShowedAt()
  }

  const onClickAdvCasinoHandler = () => {
    if (isMobile) {
      loadOrReload('/advCasino')
    } else {
      globalStore.addGeneralPopupProperties(<AdvCasino/>, '승부사카지노', { wrapClassName: '', className: 'adv-casino', isScroll: true, custom: false, clsBtn: false })
    }
    onCloseModal()
  }

  return (
    <Modal
      visible={visibleCasinoOpenPopup}
      transparent
      maskClosable={false}
      onClose={onCloseModal}
      wrapClassName="tutorial"
      className="event"
      css={AdvDialogStyle}
    >
      <CasinoOpenWrap>
        <img src={CasinoOpenImg} alt="" style={{ width: '100%' }}/>
        <Button navy className="go-casino-btn" onClick={onClickAdvCasinoHandler}>
          승부사카지노 이동
        </Button>
        <Button circle onClick={onCloseModal} css={CloseBtn} className="close-btn modal-circle-close-btn event-modal"><span className="close-txt">닫기</span></Button>
      </CasinoOpenWrap>

      <ModalBg onClick={onCloseModal} className="clickable"/>
    </Modal>
  )
}

export default observer(AdvCasinoOpenPopup)
